<template>
    <div class="shadow vacancies" v-loading="loading" v-if="vacancies.length">
        <h3 class="vacancies__title">Вакансии</h3>
        <div class="vacancies__list" v-loading="loading">
            <VacancyItem
                v-for="(vacancy, index) in vacancies"
                :vacancy="vacancy"
                :color="getColor(index)"
                :key="`${index}-${vacancy.id}`"
            />
        </div>
        <div v-if="pagination.hasNextPage" class="vacancies__load-more" @click="getVacancies">
            {{ moreText }}
        </div>
    </div>
    <EmptyTabsCard
        v-else
        :emptyImgLink="emptyImgLink"
        cardTitle="Вакансии"
        toFullRouter="/vacancies/"
        emptyText="Еще нет вакансий"
    />
</template>

<script>
import EmptyTabsCard from '@/components/UI/EmptyTabsCard.vue';
import gql from 'graphql-tag';
import VacancyItem from './components/VacancyItem.vue';
import { get } from '@/tools/http';
import declinationOfNumber from '@/tools/declinationOfNumber';

export default {
    components: {
        EmptyTabsCard,
        VacancyItem,
    },
    data() {
        return {
            loading: false,
            vacancies: [],
            projectsIds: [],
            pagination: {
                pageSize: 3,
                hasNextPage: false,
                totalCount: 0,
            },
            colors: ['#ECF4FB', '#F0F0F6', '#F0FAF2'],
        };
    },
    computed: {
        standProjectTypeId() {
            const domainToIdMap = {
                'rsv-test-2.bizml.ru': 69327,
                'rsv-test.bizml.ru': 70923,
                'rsv-demo.bizml.ru': 214074,
                'rsv-dev.bizml.ru': 59022,
            };
            return domainToIdMap[window.rsvDomain] || 218740;
        },
        emptyImgLink() {
            return require(`@/assets/images/oops-rhino-in-a-hat.svg`);
        },
        moreText() {
            const pageSize = this.pagination.pageSize;
            const showingItems = this.vacancies.length;
            const moreItems = this.pagination.totalCount - showingItems;
            const numberToShow = moreItems > pageSize ? pageSize : moreItems;
            const decTxt = declinationOfNumber(numberToShow, 'вакансия', 'вакансии', 'вакансий');
            return `Еще ${numberToShow} ${decTxt}`;
        },
    },
    async mounted() {
        this.projectsIds = await this.getProjectsIds();
        this.getVacancies(this.projectsIds);
    },

    methods: {
        getColor(index) {
            const colorIndex = index % this.colors.length;
            return this.colors[colorIndex];
        },
        vacanciesQueryBuild(projectsIds) {
            return gql`
                query {
                    vacancies(
                        skip: ${this.vacancies.length}
                        take: ${this.pagination.pageSize},
                        order: [{createdAt: ASC}],
                        where: {
                             projectId: {
                                in: ${JSON.stringify(projectsIds)}
                        },
                    })
                    {
                        items {
                            id
                            name
                            description
                            projectId
                            createdAt
                        }
                        totalCount
                        pageInfo {
                            hasNextPage
                        }
                    }
                }
            `;
        },

        async getVacancies() {
            if (!this.projectsIds.length) return;
            this.loading = true;

            try {
                const apolloClientProject2 = this.$apolloProvider.clients.apolloClientProject2;
                const result = await apolloClientProject2.query({
                    query: this.vacanciesQueryBuild(this.projectsIds),
                });
                if (result) {
                    this.vacancies = [...this.vacancies, ...result.data.vacancies.items];
                    this.pagination.hasNextPage = result.data.vacancies.pageInfo.hasNextPage;
                    this.pagination.totalCount = result.data.vacancies.totalCount;
                }
            } catch (error) {
                console.error('Error during Apollo query:', error);
            }
            this.loading = false;
        },

        async getProjectsIds() {
            let projects = [];
            try {
                const result = await get(
                    'projects2',
                    `api/v1/project/current?filter[type]=${this.standProjectTypeId}`,
                    {},
                    {}
                );
                projects = result.data;
            } catch (e) {
                console.log(e);
            }
            return projects.map((project) => project.id);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.vacancies {
    background-color: #ffffff;
    border-radius: 0.2rem;
    padding: mrem(24) mrem(16);
    display: block;

    @include on-desktop {
        padding: rem(32);
        background-color: white;
        box-shadow: 0 2px 8px rgba(155, 161, 166, 0.23626);
        border-radius: rem(10);
    }

    &__title {
        color: #2a2626;
        font-size: mrem(22);
        font-weight: 600;
        line-height: mrem(32);
        margin-top: 0;

        @include on-desktop {
            font-weight: 700;
            font-size: rem(20);
            line-height: rem(32);
        }
    }

    &__load-more {
        font-family: 'Circe Rounded', sans-serif;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: mrem(206);
        height: mrem(43);
        border: mrem(1) solid #98a0a9;
        border-radius: mrem(4);
        font-style: normal;
        font-weight: 400;
        font-size: mrem(18);
        line-height: mrem(23);
        padding-top: mrem(3);
        color: #98a0a9;
        margin: auto;
        cursor: pointer;

        &::before {
            content: ' ';
            margin-top: mrem(-3);
            margin-right: mrem(8);
            left: mrem(20);
            display: block;
            width: mrem(22);
            height: mrem(16);
            background: url('~@/assets/images/load-more.svg') no-repeat;
            background-size: mrem(23) mrem(16);
        }

        @include on-desktop {
            width: rem(200);
            height: rem(43);
            font-size: rem(18);
            border: rem(1) solid #98a0a9;
            border-radius: rem(4);
            padding-top: rem(3);

            &::before {
                margin-top: rem(-3);
                margin-right: rem(8);
                left: rem(20);
                width: rem(22);
                height: rem(16);
                background-size: rem(23) rem(16);
            }
        }
    }
}
</style>
